<template>
  <section>
    <ul class="list-unstyled ps-0 custom-links">
      <li v-for="n of nav" :key="n.root" class="mb-1">
        <button class="btn btn-toggle align-items-center rounded" :class="{ hidden: n.root.trim() === '' }"
          data-bs-toggle="collapse" :data-bs-target="`#${n.root}-collapse`" aria-expanded="true">
          {{ n.root }}
        </button>
        <div :id="`${n.root}-collapse`" class="collapse show">
          <ul class="navbar-nav btn-toggle-nav list-unstyled fw-normal pb-1 small custom-link">
            <li v-for="p of n.pages" :key="p.name" class="nav-item">
              <router-link exact :to="p.url" class="nav-link">
                <i :class="[{ hidden: p.icon.trim() === '' }, p.icon]"></i>
                <span>{{ p.name }}</span>
                <span v-if="p.url === '/opportunity' && notSeenCount > 0" title="# incoming" class="badge-incoming">{{
                  notSeenCount }}</span>
                <span v-if="p.url === '/search-shops' && numNewMembers > 0" title="# new members"
                  class="badge-new-members">{{ numNewMembers }}</span>
              </router-link>
            </li>
            <li class="nav-item d-block d-md-none">
              <a id="logout" href="#" class="nav-link" title="logout" @click="performAction('logout')">
                <i class="fas fa-sign-out-alt"></i>
                Logout
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { opportunityStore } from '@/stores/opportunity'
import { locationStore } from '@/stores/location'
import { adasIqStore } from '@/stores/adasIq'
export default {
  name: 'NavLeft',
  data() {
    return {
      searchText: '',
      isCollapsed: false,
      nav: [
        {
          root: '',
          isActive: true,
          isHidden: false,
          pages: [{ url: '/', name: 'Home', icon: '', isHidden: false }]
        }
      ],
      navSupport: []
    }
  },
  async mounted() {
    // A session from before features existed has none stored yet.
    if (!this.features) {
      await this.loadFeatures()
    }
    this.initMenu()
    this.checkAdasIq()
  },
  watch: {
    // Rebuild when a super admin switches a feature on the Features tab.
    features() {
      this.initMenu()
    },
    adasIqAllowed() {
      this.initMenu()
    }
  },
  computed: {
    ...mapState(authStore, ['profile', 'features']),
    ...mapState(adasIqStore, { adasIqAllowed: 'allowed' }),
    ...mapState(opportunityStore, ['counts']),
    ...mapState(locationStore, ['newMemberCount']),
    isSuperAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isAdmin() {
      let _is = false
      if ([2, 3, 4, 5, 7, 9, 12, 15].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isProviderAdmin() {
      let _is = false
      // 2 = Provider Group
      // 3 = Service Provider
      if ([2, 3].includes(this.profile.connectClass)) {
        if ([3, 5, 7, 9, 12].includes(this.profile.roles[0])) {
          _is = true
        }
      }
      return _is
    },
    isInsurer() {
      let _is = false
      if (this.profile.connectClass === 1) {
        _is = true
      }
      return _is
    },
    isProvider() {
      let _is = false
      // 2 = Provider Group
      // 3 = Service Provider
      if ([2, 3].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    },
    isLocator() {
      let _is = false
      // 6 = Locator Group
      // 7 = Locator
      if ([6, 7].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    },
    isLocation() {
      let _is = false
      if ([1, 2, 3, 4, 5, 7, 9, 12, 15].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    notSeenCount() {
      let _count = null
      if (this.counts) {
        _count = this.counts.notSeenCount
      }
      return _count
    },
    numNewMembers() {
      let _count = null
      if (this.newMemberCount) {
        _count = this.newMemberCount
      }
      return _count
    }
  },
  methods: {
    ...mapActions(authStore, ['clearToken', 'loadFeatures', 'isAllowed']),
    ...mapActions(adasIqStore, { checkAdasIq: 'check' }),
    initMenu() {
      let _nav = []
      const _homePages = [
        { url: '/', name: 'Home', icon: '', isHidden: false },
        // Issue 622: upload a PDF estimate on behalf of a customer (creates an ADAS inspection).
        { url: '/upload-estimate', name: 'Upload Estimate PDF', icon: 'fa-solid fa-file-upload', isHidden: false },
        // A VIN and an RO with no estimate to upload: same result, different starting point.
        { url: '/vin-inspection', name: 'Create VIN Only Inspection', icon: 'fa-solid fa-car', isHidden: false },
        // Shown to everyone who can upload: it is how they see what became of their own estimates.
        { url: '/upload-estimate-review', name: 'Estimate Upload Review', icon: 'fa-solid fa-list', isHidden: false }
      ].filter((p) => this.isAllowed(p.url))
      this.nav = [
        {
          root: '',
          isActive: true,
          isHidden: false,
          pages: _homePages
        }
      ]
      if ((this.isAdmin || this.isSuperAdmin) && !this.isProviderAdmin) {
        _nav = [
          {
            url: '/locations',
            name: 'Locations',
            icon: 'fa-solid fa-map-marker-alt',
            isHidden: false
          }
        ]
        if (this.isInsurer || this.isSuperAdmin) {
          _nav.push({
            url: '/membership',
            name: 'Membership',
            icon: 'fa-solid fa-handshake',
            isHidden: false
          })
        }
        if (this.isLocator) {
          _nav.push({
            url: '/marketing-dashboard',
            name: 'Dashboard',
            icon: 'fa-solid fa-chart-line',
            isHidden: false
          })
        } else {
          _nav.push({
            url: '/dashboard',
            name: 'Dashboard',
            icon: 'fa-solid fa-chart-line',
            isHidden: false
          })
        }
        if (this.isProvider) {
          _nav.push({
            url: '/search-shops',
            name: 'Shop Search',
            icon: 'fa-solid fa-warehouse',
            isHidden: false
          })
          _nav.push({
            url: '/opportunity',
            name: 'Requests',
            icon: 'fa-solid fa-money-check-dollar',
            isHidden: false
          })
        } else if (this.isLocator) {
          _nav.push({
            url: '/marketing-search-shops',
            name: 'Shop Search',
            icon: 'fa-solid fa-warehouse',
            isHidden: false
          })
          _nav.push({
            url: '/marketing-opportunity',
            name: 'Requests',
            icon: 'fa-solid fa-money-check-dollar',
            isHidden: false
          })
        }
      } else if (this.isProvider || this.isProviderAdmin) {
        _nav = []
        if (this.isProviderAdmin) {
          _nav.push({
            url: '/locations',
            name: 'Locations',
            icon: 'fa-solid fa-map-marker-alt',
            isHidden: false
          })
          _nav.push({
            url: '/search-shops',
            name: 'Shop Search',
            icon: 'fa-solid fa-warehouse',
            isHidden: false
          })
        }
        _nav.push({
          url: '/opportunity',
          name: 'Requests',
          icon: 'fa-solid fa-money-check-dollar',
          isHidden: false
        })
        if (this.isProviderAdmin) {
          _nav.push({
            url: '/dashboard',
            name: 'Dashboard',
            icon: 'fa-solid fa-chart-line',
            isHidden: false
          })
        }
      } else if (this.isLocation) {
        _nav = [
          {
            url: '/locations',
            name: 'Locations',
            icon: 'fa-solid fa-map-marker-alt',
            isHidden: false
          }
          // {
          //   url: '/dashboard',
          //   name: 'Dashboard',
          //   icon: 'fa-solid fa-chart-line',
          //   isHidden: false
          // }
        ]
        // } else {
        //   _nav = [
        //     {
        //       url: '/dashboard',
        //       name: 'Dashboard',
        //       icon: 'fa-solid fa-chart-line',
        //       isHidden: false
        //     }
        //   ]
      } else {
        if (this.isInsurer) {
          _nav.push({
            url: '/dashboard',
            name: 'Dashboard',
            icon: 'fa-solid fa-chart-line',
            isHidden: false
          })
        }
      }
      if (this.isSuperAdmin) {
        _nav.push({
          url: '/configuration',
          name: 'Configuration',
          icon: 'fa-solid fa-sliders',
          isHidden: false
        },
          {
            url: '/reports/provider-billing',
            name: 'Transaction Report',
            icon: 'fa-solid fa-file-invoice-dollar',
            isHidden: false
          }
        )
      }

      // #620: ADAS IQ, only for users ADAS IQ says may use it (the Launchpad access flag, asked
      // once per page load; see stores/adasIq.js). Providers, provider admins and OPUS admins;
      // insurer users wait on the cross-shop history decision (ADAS IQ ADR-0003).
      if (this.adasIqAllowed && !this.isInsurer) {
        _nav.push({
          url: '/adas-iq',
          name: 'ADAS IQ',
          icon: 'fa-solid fa-comments',
          isHidden: false
        })
      }

      // The items are gathered by role above, in whatever order those branches happen to run. The menu
      // the user reads has its own order, applied here so the role logic stays untouched. Anything not
      // named keeps its existing relative position, after the named ones.
      const MENU_ORDER = [
        'Home',
        'Requests',
        'Locations',
        'Upload Estimate PDF',
        'Estimate Upload Review',
        'Create VIN Only Inspection',
        'Shop Search',
        'Dashboard'
      ]
      const ranked = this.nav[0].pages.concat(_nav).map((page, index) => {
        const named = MENU_ORDER.indexOf(page.name)
        return { page, rank: named < 0 ? MENU_ORDER.length : named, index }
      })
      ranked.sort((a, b) => (a.rank - b.rank) || (a.index - b.index))
      this.nav[0].pages = ranked.map((r) => r.page)

      this.navSupport = [
        { name: 'About', icon: '', action: 'about' },
        { name: 'Logout', icon: '', action: 'logout' }
      ]
      console.log('Nav Items', this.nav)
    },
    isActive() {
      return true
    },
    isVisible(pages) {
      return pages.some((p) => this.store.isAllowed(p.url))
    },
    search() {
      this.isCollapsed = false
      for (let n of this.nav) {
        n.isHidden = false
        let count = 0
        for (let p of n.pages) {
          p.isHidden = !p.name.toLowerCase().includes(this.searchText.toLowerCase())
          if (!p.isHidden) {
            count++
          }
        }
        n.isHidden = !count
      }
      this.$forceUpdate()
    },
    performAction(action) {
      if (action === 'about') {
        this.$router.push('/about')
      } else if (action === 'logout') {
        this.clearToken()
        window.location.assign('/')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.hidden {
  display: none;
}

.custom-active {
  font-weight: 500;
  color: #007bff;
}

.custom-links {
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-left: -15px;
  margin-right: -15px;
}

.custom-link {
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;

  svg {
    width: 36px;
  }

  a {
    display: block;
    padding: 0.25rem 1.5rem;
    margin-top: 5px;
    margin-bottom: 5px;
    color: #fff;
  }
}

.badge-incoming {
  position: relative;
  top: -5px;
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: white;
  background: red;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  font-weight: normal;
  font-size: 12px;
  border-radius: 18px;
  padding: 0 4px;
  height: 18px;
  min-width: 18px;
}

.badge-new-members {
  position: relative;
  top: -5px;
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: white;
  background: green;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  font-weight: normal;
  font-size: 12px;
  border-radius: 18px;
  padding: 0 4px;
  height: 18px;
  min-width: 18px;
}
</style>
